(function () {
  'use strict';

  var SAMPLE_TAG = 'single-sample';
  var SAMPLE_HANDLES = [
    'strawberries-cream-pea-protein-sample-sachet-30g',
    'salted-caramel-cookie-pea-protein-sample-sachet-30g',
    'french-vanilla-pea-protein-sample-sachet-30g',
    'copy-of-double-chocolate-fudge-pea-protein-sample-sachet'
  ];
  var MIN_CART_CENTS = 3000;
  var BUNDLE_QTY = 8;
  var lastAllow = true;

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return '$' + amount;
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  function isSampleItem(item) {
    if (item && item.handle && SAMPLE_HANDLES.indexOf(item.handle) !== -1) return true;
    if (Array.isArray(item.product_tags)) {
      for (var i = 0; i < item.product_tags.length; i++) {
        if (String(item.product_tags[i]).toLowerCase() === SAMPLE_TAG) return true;
      }
    } else if (typeof item.product_tags === 'string') {
      if (item.product_tags.toLowerCase().indexOf(SAMPLE_TAG) !== -1) return true;
    }
    return false;
  }

  function qualifyingSubtotal(cart) {
    var total = 0;
    cart.items.forEach(function (item) {
      if (!isSampleItem(item)) total += item.final_line_price || (item.price * item.quantity);
    });
    return total;
  }

  function sampleQty(cart) {
    var qty = 0;
    cart.items.forEach(function (item) {
      if (isSampleItem(item)) qty += item.quantity;
    });
    return qty;
  }

  function applyCheckoutGate(cart) {
    var sQty = sampleQty(cart);
    var qSub = qualifyingSubtotal(cart);
    var samplesInCart = sQty > 0;
    var bundleComplete = sQty === BUNDLE_QTY;
    var qualifies = qSub >= MIN_CART_CENTS;
    var allow = !samplesInCart || bundleComplete || qualifies;
    lastAllow = allow;

    // Find all checkout submit buttons + cart forms
    var forms = document.querySelectorAll('cart-drawer form, form[action$="/cart"], form[action*="/cart?"], main-cart form');
    forms.forEach(function (form) {
      // Skip upsell / add-to-cart forms — only gate the real checkout form
      if (form.hasAttribute('data-cart-upsell-form')) return;
      if (form.action && /\/cart\/add/i.test(form.action)) return;

      var btns = form.querySelectorAll('button[name="checkout"]');
      btns.forEach(function (btn) {
        if (allow) {
          btn.disabled = false;
          btn.removeAttribute('aria-disabled');
          btn.style.opacity = '';
          btn.style.pointerEvents = '';
        } else {
          btn.disabled = true;
          btn.setAttribute('aria-disabled', 'true');
          btn.style.opacity = '0.5';
          btn.style.pointerEvents = 'none';
        }
      });

      // Bind submit interceptor once per form
      if (!form.dataset.sampleGateBound) {
        form.dataset.sampleGateBound = '1';
        form.addEventListener('submit', function (e) {
          if (!lastAllow) {
            e.preventDefault();
            e.stopPropagation();
            return false;
          }
        }, true);
      }
    });

    // Also hide dynamic payment buttons (Shop Pay, PayPal etc.) when blocked
    document.querySelectorAll('.shopify-payment-button, .additional-checkout-buttons').forEach(function (el) {
      el.style.display = allow ? '' : 'none';
    });

    // Render / remove warning banner inside cart drawer + cart page
    var hosts = document.querySelectorAll('cart-drawer .cart-drawer__footer, form[action$="/cart"], main-cart');
    hosts.forEach(function (host) {
      var existing = host.querySelector('.sample-cart-warning');
      if (allow) {
        if (existing) existing.remove();
        return;
      }
      var needed = MIN_CART_CENTS - qSub;
      var msg = 'Add ' + formatMoney(Math.max(0, needed)) +
        ' more to your cart, or complete an 8-piece bundle, to checkout with samples.';
      if (existing) {
        var p = existing.querySelector('p');
        if (p) p.textContent = msg;
      } else {
        var div = document.createElement('div');
        div.className = 'sample-cart-warning';
        div.setAttribute('role', 'alert');
        div.style.cssText = 'background:#fff3cd;border:1px solid #ffe69c;color:#664d03;padding:10px 12px;border-radius:6px;margin:8px 0;font-size:0.8125rem;line-height:1.4;';
        div.innerHTML = '<p style="margin:0"></p>';
        div.querySelector('p').textContent = msg;
        host.insertBefore(div, host.firstChild);
      }
    });
  }

  function applyState(subtotal) {
    document.querySelectorAll('product-card[data-requires-min-cart]').forEach(function (card) {
      var min = parseInt(card.getAttribute('data-requires-min-cart'), 10) || 0;
      card.style.display = subtotal >= min ? '' : 'none';
    });

    document.querySelectorAll('sample-gate').forEach(function (gate) {
      var min = parseInt(gate.getAttribute('data-min-cart'), 10) || 0;
      var unlocked = subtotal >= min;
      gate.setAttribute('data-locked', unlocked ? 'false' : 'true');
      var msg = gate.querySelector('.sample-gate__message');
      if (msg) msg.style.display = unlocked ? 'none' : '';
      var remainEl = gate.querySelector('[data-sample-gate-remaining]');
      if (remainEl) remainEl.textContent = formatMoney(Math.max(0, min - subtotal));
      gate.querySelectorAll('button[type="submit"], input[type="submit"]').forEach(function (btn) {
        btn.disabled = !unlocked;
        if (!unlocked) {
          btn.setAttribute('aria-disabled', 'true');
        } else {
          btn.removeAttribute('aria-disabled');
        }
      });
    });
  }

  function refresh() {
    fetchCart().then(function (cart) {
      applyState(qualifyingSubtotal(cart));
      applyCheckoutGate(cart);
    }).catch(function () {});
  }

  // Patch fetch to refresh after cart mutations
  var origFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    var promise = origFetch.apply(this, args);
    if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
      promise.then(function () { setTimeout(refresh, 50); }).catch(function () {});
    }
    return promise;
  };

  document.addEventListener('DOMContentLoaded', refresh);
  document.documentElement.addEventListener('cart:refresh', refresh);
})();
